import { render, staticRenderFns } from "./DepositDetails.vue?vue&type=template&id=abd973d0&"
import script from "./DepositDetails.vue?vue&type=script&lang=js&"
export * from "./DepositDetails.vue?vue&type=script&lang=js&"
import style0 from "./DepositDetails.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports